import React from 'react';
import toast from 'react-hot-toast';

import { CrossIcon, TickIcon } from '~/assets';
import NewsIcon from '~/assets/NewsIcon';
import {
  CrossContainer,
  DownloadContainer,
  InfoContainer,
  InformationContainer,
  StyledCrossIcon,
  TickContainer,
} from '~/components/ToastComponent/ToastComponent.styles';

export enum ToastMode {
  Success,
  Error,
  Information,
}
interface ToastComponentProps {
  text: string;
  id?: string;
  mode?: ToastMode;
  darkMode?: boolean;
}

const ToastComponent = ({ text, id, mode, darkMode = false }: ToastComponentProps) => {
  const getIcon = () => {
    switch (mode) {
      case ToastMode.Success:
        return (
          <TickContainer>
            <TickIcon />
          </TickContainer>
        );
      case ToastMode.Error:
        return (
          <CrossContainer>
            <CrossIcon />
          </CrossContainer>
        );
      default:
        return (
          <InformationContainer>
            <NewsIcon />
          </InformationContainer>
        );
    }
  };

  return (
    <DownloadContainer $darkMode={darkMode}>
      <InfoContainer>
        {getIcon()}
        {text}
      </InfoContainer>
      <StyledCrossIcon onClick={() => toast.remove(id)} />
    </DownloadContainer>
  );
};

export default ToastComponent;
